module.exports = __webpack_public_path__ + "static/colorcoded-e47e4d726aebb2ba98a6a3a2f69bd53d.png";